(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 9536:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8476);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/color-mode/dist/chakra-ui-color-mode.esm.js
var chakra_ui_color_mode_esm = __webpack_require__(4709);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(4896);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(2751);
// EXTERNAL MODULE: ../packages/ui/dist/index.mjs
var dist = __webpack_require__(9);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(3018);
// EXTERNAL MODULE: ../node_modules/fuse.js/dist/fuse.esm.js
var fuse_esm = __webpack_require__(2631);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(9894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5230);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/menu/dist/chakra-ui-menu.esm.js + 3 modules
var chakra_ui_menu_esm = __webpack_require__(987);
// EXTERNAL MODULE: ./pages/account/index.tsx
var account = __webpack_require__(5858);
// EXTERNAL MODULE: ../node_modules/@chakra-ui/image/dist/chakra-ui-image.esm.js
var chakra_ui_image_esm = __webpack_require__(6213);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ./utils/accountService/accountManager.tsx
var accountManager = __webpack_require__(8608);
// EXTERNAL MODULE: ./utils/accountService/messageModal.tsx
var messageModal = __webpack_require__(4147);
;// CONCATENATED MODULE: ./utils/accountService/displayAccountStatus.tsx











function DisplayAccountStatus() {
    var DisplaySignedInUser = function DisplaySignedInUser() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                justifyContent: "flex-end",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_menu_esm/* Menu */.v2, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuButton */.j2, {
                            as: chakra_ui_layout_esm/* Flex */.kC,
                            alignItems: "center",
                            transition: "all 0.2s ease-in-out",
                            _hover: {
                                color: "whiteAlpha.500",
                                cursor: "pointer",
                                boxShadow: "dark-lg",
                                transform: "scale(1.025)"
                            },
                            _expanded: {
                                color: "whiteAlpha.500",
                                cursor: "pointer",
                                boxShadow: "0 1px 0 0 white"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Image */.Ee, {
                                        boxSize: "2rem",
                                        borderRadius: "full",
                                        src: "https://placekitten.com/100/100",
                                        alt: "Profile picture"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                                        as: index_esm/* MdArrowDropDown */.gwH,
                                        w: 6,
                                        h: 6,
                                        color: "whiteAlpha.800"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_menu_esm/* MenuList */.qy, {
                            textColor: "white",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                                    mt: "2",
                                    ml: "3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            fontSize: 14,
                                            children: "Signed in as:"
                                        }),
                                        accountManager/* default.UserEmail */.Z.UserEmail
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuDivider */.R, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuItem */.sN, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                                        as: index_esm/* MdSettings */.b9P
                                    }),
                                    onClick: function() {
                                        router.push(account.userDetailsPage);
                                    },
                                    children: "Projects"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_menu_esm/* MenuItem */.sN, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdExitToApp */.IUz, {}),
                                    onClick: handleSignOut,
                                    children: "Sign out"
                                })
                            ]
                        })
                    ]
                })
            })
        });
    };
    var DisplayGuestUser = function DisplayGuestUser() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        as: "a",
                        p: 2,
                        transition: "all 0.2s ease-in-out",
                        _hover: {
                            boxShadow: "lg",
                            transform: "scale(1.025)",
                            cursor: "pointer"
                        },
                        color: "white",
                        onClick: function() {
                            return router.push(account.signInPage);
                        },
                        children: "Sign in"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* CustomCard */._t, {
                        as: "a",
                        variant: "acrylic",
                        background: "blackAlpha.500",
                        p: 2,
                        transition: "all 0.2s ease-in-out",
                        _hover: {
                            boxShadow: "lg",
                            transform: "scale(1.025)",
                            bg: "blackAlpha.50",
                            cursor: "pointer"
                        },
                        role: "group",
                        onClick: function() {
                            return router.push(account.signUpPage);
                        },
                        children: "Create account"
                    })
                ]
            })
        });
    };
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), userSignedIn = ref[0], setUserSignedIn = ref[1];
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var customToast = (0,messageModal/* useCustomToast */.g)();
    var handleSignOut = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return accountManager/* default.SignOut */.Z.SignOut();
                    case 2:
                        response = _ctx.sent;
                        if (response.status == accountManager/* AccountResponseStatus.SUCCESS */.j.SUCCESS) {
                            router.push(account.signInPage);
                        }
                        customToast({
                            description: response.message,
                            status: response.status == accountManager/* AccountResponseStatus.SUCCESS */.j.SUCCESS ? "success" : "error"
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSignOut() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        GetAccountStatus();
    }, []);
    function GetAccountStatus() {
        return _GetAccountStatus.apply(this, arguments);
    }
    function _GetAccountStatus() {
        _GetAccountStatus = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return accountManager/* default.GetSession */.Z.GetSession();
                    case 2:
                        response = _ctx.sent;
                        if (response.status == accountManager/* AccountResponseStatus.SUCCESS */.j.SUCCESS) {
                            setUserSignedIn(true);
                        } else {
                            setUserSignedIn(false);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _GetAccountStatus.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: userSignedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplaySignedInUser, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayGuestUser, {})
    });
};

;// CONCATENATED MODULE: ./pages/index.tsx








var __N_SSG = true;
function Home(param) {
    var localSlugs = param.localSlugs, slugs = param.slugs;
    var ref = (0,react.useState)(""), query = ref[0], setQuery = ref[1];
    var allSlugs = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(localSlugs.map(function(slug) {
            return {
                slug: slug,
                location: "local"
            };
        })).concat((0,_to_consumable_array/* default */.Z)(slugs.map(function(slug) {
            return {
                slug: slug,
                location: "remote"
            };
        })));
    }, [
        localSlugs,
        slugs
    ]);
    var fuse = (0,react.useMemo)(function() {
        return new fuse_esm/* default */.Z(allSlugs, {
            keys: [
                "slug"
            ],
            threshold: 0.3,
            isCaseSensitive: false,
            shouldSort: true,
            sortFn: function(a, b) {
                if (allSlugs[a.idx].location === allSlugs[b.idx].location) {
                    return a.score - b.score;
                } else if (allSlugs[a.idx].location === "local") {
                    return -1;
                } else {
                    return 1;
                }
            }
        });
    }, [
        allSlugs
    ]);
    var results = (0,react.useMemo)(function() {
        return query ? fuse.search(query).map(function(result) {
            return result.item;
        }) : allSlugs;
    }, [
        query,
        fuse,
        allSlugs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_color_mode_esm/* DarkMode */.t7, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
            px: {
                base: 4,
                sm: 8,
                md: 16,
                lg: 32
            },
            py: {
                base: 4,
                sm: 8,
                md: 16,
                lg: 8
            },
            overflowY: "auto",
            h: "full",
            bgGradient: "linear(to-br, pink.700, purple.900, gray.900, gray.900)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAccountStatus, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                    py: {
                        base: 4,
                        sm: 8,
                        md: 16,
                        lg: 16
                    },
                    mb: 16,
                    maxWidth: "xl",
                    color: "white",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                            as: "h1",
                            size: "3xl",
                            mb: 4,
                            children: "3D Scenes"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                            as: "h2",
                            size: "lg",
                            fontWeight: "light",
                            mb: 8,
                            children: "Showcase of real estate, cultural heritage, and other 3D environments in our Web Player"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, {
                            type: "search",
                            placeholder: "Search",
                            value: query,
                            onChange: function(e) {
                                return setQuery(e.target.value);
                            },
                            autoFocus: true,
                            color: "gray.800",
                            variant: "solid",
                            size: "lg"
                        })
                    ]
                }),
                results.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                    maxWidth: "xl",
                    color: "white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "xl",
                        fontWeight: "light",
                        children: "No results found"
                    })
                }),
                results.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Grid */.rj, {
                    templateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                    gap: 6,
                    children: results.map(function(param) {
                        var location = param.location, slug = param.slug;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/player/".concat(slug).concat(location === "local" ? "?local=true" : ""),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* CustomCard */._t, {
                                as: "a",
                                variant: "acrylic",
                                p: 6,
                                transition: "all 0.2s ease-in-out",
                                _hover: {
                                    boxShadow: "lg",
                                    transform: "scale(1.025)",
                                    bg: "blackAlpha.500"
                                },
                                role: "group",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                                    justifyContent: "space-between",
                                    w: "full",
                                    overflow: "hidden",
                                    spacing: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                                            flex: "1",
                                            minW: 0,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                                                    as: "h3",
                                                    size: "sm",
                                                    fontWeight: "bold",
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    mb: 1,
                                                    children: slug
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                    fontSize: "xs",
                                                    fontWeight: "light",
                                                    color: "whiteAlpha.700",
                                                    textTransform: "uppercase",
                                                    letterSpacing: "widest",
                                                    children: location
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                                            as: location === "local" ? index_esm/* MdOutlineHome */.Vp$ : index_esm/* MdOutlineCloud */.LiV,
                                            w: 6,
                                            h: 6,
                                            color: "whiteAlpha.500",
                                            transition: "all 0.2s ease-in-out",
                                            _groupHover: {
                                                color: "whiteAlpha.800"
                                            }
                                        })
                                    ]
                                })
                            })
                        }, "".concat(slug, "-").concat(location));
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 4147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useCustomToast; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9722);
/* harmony import */ var _treasured_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9345);


var useCustomToast = function() {
    var toast = (0,_treasured_ui__WEBPACK_IMPORTED_MODULE_0__/* .useToast */ .pm)();
    var customToast = function(options) {
        return toast((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            isClosable: true,
            position: "top-right",
            duration: 5000
        }, options));
    };
    return customToast;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,873,336,325,987,102,858,774,888,179], function() { return __webpack_exec__(9536); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);